const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Services/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Services/Search')

export default [
  {
    path: 'services/create',
    name: 'ServicesCreate',
    component: Single,
    meta: {
      title: 'Adicionar Serviço',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'services',
        action: 'create'
      }
    }
  },
  {
    path: 'services/:id',
    name: 'ServicesEdit',
    component: Single,
    meta: {
      title: 'Editar Serviço',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'services',
        action: 'read'
      }
    }
  },
  {
    path: 'services',
    name: 'ServicesSearch',
    component: Search,
    meta: {
      title: 'Serviços',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'services',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/services.js